import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { REST_API } from 'drapcode-constant';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CardForMapping from './CardForMapping';
import ReponseDataKeyMappingToUserField from './ReponseDataKeyMappingToUserField';

export default class CurrentUserResponseDataMapping extends Component {
  render() {
    const { handleChange, itemsPath, selectedMapping, statusPath, currentUserPrimaryKey } =
      this.props;
    const subtitle = 'Current LoggedIn User Response Mapping';
    const subtext = '( We will login and/or regiter the user with the response from API )';

    return (
      <CardForMapping
        color="drapcode-violet"
        title="Current LoggedIn User Response Mapping"
        displayTitle={false}
        subtitle={subtitle}
        subtext={subtext}
      >
        <div className="row pb-3">
          <div className="col-6">
            <CustomInputWithIcon icon="text">
              <input
                type="text"
                name="currentUserStatusPath"
                className="form-control form-control-sm"
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                value={statusPath}
                placeholder="Response Status Path"
              />
            </CustomInputWithIcon>
          </div>
          <ReponseDataKeyMappingToUserField
            handleChange={handleChange}
            itemsPath={itemsPath}
            selectedCollectionName={'user'}
            selectedMapping={selectedMapping}
            connectorType={REST_API}
            currentUserPrimaryKey={currentUserPrimaryKey}
          />
        </div>
      </CardForMapping>
    );
  }
}
